export default {
  title: "Issues",
  table_column_title_label: "Title",
  table_column_entity_label: "Entity",
  table_column_entity_grouping_label: "Entity Grouping",
  table_column_layout_label: "Layout",
  table_column_raised_label: "Raised",
  table_column_closed_date_label: "Closed date",
  table_column_updated_label: "Last Updated",
  table_column_work_domain_label: "Work domain",
  table_column_priority_label: "Priority",
  table_column_entity_grouping_item_class: "Item Class",
  table_column_entity_grouping_area_attribute_set: "Area Attribute Set",
  item: "Item",
  tab_issue: "Issue",
  tab_item: "Item",
  tab_accepted_corrective_work: "Accepted Corrective Work",
  tab_corrective_work: "Corrective Work",
  tab_events: "Events",
  tab_comments: "Comments",
  title_state_and_history: "State and History",
  work_domain_label: "Work domain",
  deadline_label: "Deadline for Correction",
  issue_description_label: "Issue description",
  model_label: "Model",
  correction_info_label: "Correction Information",
  corrective_action_label: "Corrective Action",
  material_requirements_label: "Material requirements",
  time_requirements_label: "Time requirements",
  additional_requirements_label: "Additional requirements",
  isolation: "Isolation",
  shutdown: "Shutdown",
  designation_label: "Designation",
  title_raise_issue: "Raise Issue",
  entity_ref_label: "Existing Issues",
  select_priority_label: "Select a Priority",
  issue_more_info: "Provide more information about the Issue",
  placeholder_issue_designation: "Issue Designation",
  placeholder_title_reference: "__-____",
  issue_state_display: "Issue state display",
  issue_overview: "Issue Overview",
  no_correction_info: "No Correction Information",
  no_correction_info_given: "No Correction Information has been given.",
  no_correction_info_quote: "Must be self-sealing stem bolts...",
}
